
import { ReportForm } from '@cms/components/forms/ReportForm'
import { generateSearchParam, renderSubtypeLabel } from '@cms/utils/helpers'
import { COMMON_RESOURCES, ISystemJob, ISystemReport, SUBTYPES } from '@dl/declarations'
import clsx from 'clsx'
import { useCallback } from 'react'
import { Link } from 'react-router-dom'
import { DataPart } from '../../components/ui/DataPart'
import PageContainer from '../../components/ui/PageContainer'
import { renderRouteOptions, ReportsPath, Routes } from '../../utils/routes'

const ReportsPage = () => {

    const renderItem = useCallback((item: ISystemReport) => {
        return (
            <Link
                className={clsx(
                    'py-4 ps-4 pe-12 w-full',
                    'flex items-center gap-8',
                    'border border-cs-700 rounded-md',
                )}
                to={{
                    pathname: Routes.REPORTS,
                    search: `?${generateSearchParam(ReportsPath, "mode", "update")}&${generateSearchParam(ReportsPath, "id", item._id)}`,
                }}
                key={item._id}
            >
                <div
                    className='bg-cs-200 text-cs-900 font-semibold p-1'
                >
                    {renderSubtypeLabel(item.subtypeObject!, "SHORT")}
                </div>

                <img
                    src={item.reportImageObject?.src_url}
                    alt={item.name}
                    className='w-24 h-auto'
                />

                <h4 className='text-cs-600 font-semibold'>
                    {item.name}
                </h4>

                <p>
                    {item.description}
                </p>
            </Link>
        )
    }, [])

    return (
        <PageContainer
            title={renderRouteOptions(Routes.REPORTS).title}
        >
            <DataPart<ISystemJob>
                tableSize='full'

                distribution={{
                    type: 'grid',
                    noOfColumns: "1",
                    renderItem: renderItem
                }}

                queryOptions={{
                    basePath: COMMON_RESOURCES.REPORTS.ROUTE
                }}

                updateOptions={{
                    allow: true,
                    hide: true
                }}
                createOptions={{
                    allow: true
                }}
                searchOptions={{
                    allow: true
                }}

                filters={{
                    subtypes: {
                        type: 'select',
                        label: 'Subtypes',
                        options: [],
                        allowMultiSelect: true,
                        hide: true
                    },
                }}

                form={<ReportForm />}

                subtypes={[
                    SUBTYPES.NEWS,
                    SUBTYPES.RESEARCH,
                ]}
            />
        </PageContainer>
    )
}

export default ReportsPage